import { render, staticRenderFns } from "./PopupStatic.vue?vue&type=template&id=78213b9a"
import script from "./PopupStatic.vue?vue&type=script&lang=js"
export * from "./PopupStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports